import { useQuery } from '@tanstack/react-query';
import { APIClinicBilling } from 'lib/api/firebase/apis/api-clinic-balance';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';
import { useClinicianContext } from '../use-resolveCurrentClinicInfo';

export function useGetInvoice(invoiceId: string) {
  const clinicianContext = useClinicianContext();
  const clinicId = clinicianContext.currentClinic;

  return useQuery({
    queryKey: queryKeyFactory.clinic.billing.getInvoice(clinicId, invoiceId),
    queryFn: () =>
      APIClinicBilling.getInvoice({ clinicId, invoiceId }).then(
        res => res.data
      ),
    enabled: !!clinicId && !!invoiceId
  });
}
